import { type InputHTMLAttributes, forwardRef } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  hasError?: boolean;
};

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { hasError = false, className = "", ...props },
  ref,
): JSX.Element {
  return (
    <input
      ref={ref}
      className={`block w-full rounded-md border bg-white px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-brand-500/60 focus:outline-none focus:ring-2 focus:ring-offset-1 dark:bg-surface-card dark:text-text-primary dark:placeholder:text-brand-100/30 dark:shadow-none dark:focus:ring-offset-brand-900 ${
        hasError
          ? "border-red-400 focus:ring-red-400 dark:border-red-500/60"
          : "[border-color:var(--p-slate-150)] focus:ring-brand-500 dark:border-white/10 dark:focus:ring-brand-teal"
      } ${className}`}
      {...props}
    />
  );
});
